import {
  BeginPurchaseResponseDto,
  MarketOrderDto,
  MarketProductReviewDto,
  PurchaseRequestProductDto,
} from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class MarketFrontEndOrderActions extends CaEntityActionsFactory<
  MarketOrderDto,
  unknown,
  unknown,
  BaseFilterType
> {
  constructor() {
    super(`MarketFrontEndOrders`);
  }

  clearPurchaseFlowAction = createAction(`[${this.type}][Request] Clear Purchase Flow`);

  beginPurchaseFlowAction = createAction(
    `[${this.type}][Request] Begin Purchase Flow`,
    props<{ customerId: string; products: PurchaseRequestProductDto[]; paymentMethodId: string }>(),
  );

  beginPurchaseFlowSuccessAction = createAction(
    `[${this.type}][Response][Success] Begin Purchase Flow`,
    props<{
      customerId: string;
      products: PurchaseRequestProductDto[];
      response: BeginPurchaseResponseDto;
    }>(),
  );

  beginPurchaseFlowFailureAction = createAction(
    `[${this.type}][Response][Failure] Begin Purchase Flow`,
    props<{ error: any; products: PurchaseRequestProductDto[] }>(),
  );

  // Triggered by a payment processor, when a payment is complete.
  purchaseFlowCompleteAction = createAction(
    `[${this.type}][Request] Purchase Flow Complete`,
    props<{ orderId: string }>(),
  );

  reviewProductAction = createAction(
    `[${this.type}][Request] Review Product`,
    props<{ orderId: string; productId: string; rating: number; reviewBody: string }>(),
  );

  reviewProductSuccessAction = createAction(
    `[${this.type}][Response][Success] Review Product`,
    props<{
      response: MarketProductReviewDto;
    }>(),
  );

  reviewProductFailureAction = createAction(
    `[${this.type}][Response][Failure] Review Product`,
    props<{ error: any }>(),
  );

  respondToReviewAction = createAction(
    `[${this.type}][Request] Respond To Review`,
    props<{ reviewId: string; responseBody: string }>(),
  );

  respondToReviewSuccessAction = createAction(
    `[${this.type}][Response][Success] Respond To Review`,
    props<{ response: MarketProductReviewDto }>(),
  );

  respondToReviewFailureAction = createAction(
    `[${this.type}][Response][Failure] Respond To Review`,
    props<{ error: any }>(),
  );

  // Requests all orders for the current user
  requestMyAllForSegmentAction = createAction(
    `[${this.type}][Request] Request All Orders For Myself For Segment`,
    props<{ segment: string; filter?: BaseFilterType; clear?: boolean }>(),
  );
}

export const MarketFrontEndOrders = new MarketFrontEndOrderActions();
